import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

const $http = new APIManager();

const Api = {
  /* [POST] PushTemplate */
  sendPush: (data) => $http.post(APIConstant.SEND_PUSH, data),
  /* [GET] PushTemplate */
  getPushTemplates: (q = {}) => $http.get(APIConstant.GET_PUSH_TEMPLATES, q),
  /* [GET] PushTemplate */
  getUsersWithDevice: (q = {}) =>
    $http.get(APIConstant.GET_USERS_WITH_DEVICE, q),
  /* [GET] history */
  getPushHistory: (q = {}) => $http.get(APIConstant.GET_PUSH_HISTORY2, q),
};

export default Api;
